import { Icon } from '@/components/ui/icon';
import React, { useState, useEffect } from 'react';

type PaginationProps = {
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  currentPage: number;
}

export default function Pagination({ totalItems, itemsPerPage, onPageChange, currentPage: currentPageProp }: PaginationProps) {
  const [currentPage, setCurrentPage] = useState(currentPageProp);

  useEffect(() => {
    setCurrentPage(currentPageProp);
  }, [currentPageProp]);

  const totalPages = Math.ceil(totalItems / (itemsPerPage));

  const handleNext = () => {
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      onPageChange(nextPage);
    }
  }

  const handlePrev = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      setCurrentPage(prevPage); 
      onPageChange(prevPage);
    }
  }

  return (
    <div className="flex justify-end">
      <span className="font-lato text-base font-medium leading-snug flex items-center justify-center pr-2">Page</span>
      <button onClick={handlePrev} disabled={currentPage === 1}>
        <Icon name="app--previous" className="h-4 w-4" />
      </button>
      <span className="w-8 h-8 border-b border-2 rounded-xl flex items-center justify-center mx-4">{currentPage}</span>
      <button onClick={handleNext} disabled={currentPage === totalPages}>
        <Icon name="app--next" className="h-4 w-4" />
      </button>
      <span className="font-lato text-base font-medium leading-snug flex items-center justify-center pl-2">of {totalPages}</span>
    </div>
  );
}